<ng-container [ngSwitch]="language$ | async" class="ion-padding">
  <app-cgu-loyalty-en *ngSwitchCase="'en'"></app-cgu-loyalty-en>
  <app-cgu-loyalty-fr *ngSwitchCase="'fr'"></app-cgu-loyalty-fr>
</ng-container>
